import React from "react";
import CurrentOutput from "./containers/CurrentOutput";
import CurrentInput from "./containers/CurrentInput";
import Results from "./Results";

const DesktopLayout = () => {
  return (
    <div
      className="DesktopLayout"
      style={{ flex: "1 1 auto", display: "flex" }}
    >
      <CurrentInput />
      <Results />
      <CurrentOutput />
    </div>
  );
};

export default DesktopLayout;



// WEBPACK FOOTER //
// ./src/DesktopLayout.js